import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

export default class SlideOnScroll {
	constructor(element) {
		this.element = element;
		this.init();
	}

	init() {
		const screenWidth = window.innerWidth;
		if (screenWidth > 900) {

			const tl = gsap.timeline();

			const slide1Width = document.querySelector('.hero__slide-1:nth-child(1)').offsetWidth;

			// Main animation
			tl.to('.hero__slide-1:nth-child(1)', { zIndex: 1, duration: 0, opacity: 1 })
				//Animatie 2
				.fromTo(
					'.hero__slide-1:nth-child(2)',
					{
						duration: 2,
						width: 80, // Start 80px
						x: slide1Width, //  Start position next to the first slide
						ease: 'power2.out',
						zIndex: 2,
						opacity: 1,
					},
					{
						width: slide1Width, //  End with full width
						x: 80, // End position on x after 100% width of the first slide
						ease: 'power2.out',
						zIndex: 2,
						opacity: 1,
					}
				)
				.from('.hero__slide-1:nth-child(2) .hero__img-container', {
					opacity: 0,
					duration: 0.8,
					ease: 'power2.out',
					x: 80,
				}, "<")
				.fromTo(
					'.hero__slide-1:nth-child(2) .hero__content',
					{
						opacity: 0,
						yPercent: 40,
					},
					{
						opacity: 1,
						ease: 'power2.out',
						yPercent: 40,
						duration: 0.8,
					}, "<"
				)
				// .delay(3) // Delay

				// Animation for Slide 3
				.fromTo(
					'.hero__slide-1:nth-child(3)',
					{
						duration: 2,
						width: 80, // Start with 80% of the first slide's width
						x: slide1Width + 80,
						ease: 'power2.out',
						zIndex: 3,
						opacity: 1,
					},
					{
						width: slide1Width,
						x: 160, // End position on x after 100% width of the first slide
						ease: 'power2.out',
						zIndex: 3,
					}
				)
				.from('.hero__slide-1:nth-child(3) .hero__img-container', {
					opacity: 0,
					duration: 0.8,
					ease: 'power2.out',
					x: 160,
				}, "<")
				.fromTo(
					'.hero__slide-1:nth-child(3) .hero__content',
					{
						opacity: 0,
						yPercent: 40,
					},
					{
						opacity: 1,
						ease: 'power2.out',
						yPercent: 40,
						duration: 0.8,
					}, "<"
				)

				// Animation for Slide 4
				.fromTo(
					'.hero__slide-1:nth-child(4)',
					{
						duration: 2,
						width: 80,
						x: slide1Width + 160, // // Start position next to the first slide
						ease: 'power2.out',
						zIndex: 4,
						opacity: 1,
					},
					{
						width: slide1Width,
						x: 240,
						ease: 'power2.out',
						zIndex: 4,
					}
				)
				.from('.hero__slide-1:nth-child(4) .hero__img-container', {
					opacity: 0,
					duration: 0.8,
					ease: 'power2.out',
					x: 240,
				}, "<")
				.fromTo(
					'.hero__slide-1:nth-child(4) .hero__content',
					{
						opacity: 0,
						yPercent: 40,
					},
					{
						opacity: 1,
						ease: 'power2.out',
						yPercent: 40,
						duration: 0.8,
					}, "<"
				);

			// ScrollTrigger voor dia-animation
			ScrollTrigger.create({
				animation: tl,
				trigger: '.hero',
				start: 'top top',
				// end: '+=2000',
				scrub: true,
				pin: true,
				anticipatePin: 1,
			});

			// Animatie on pageload
			const pageloadAnimation = gsap.timeline();

			pageloadAnimation
				.fromTo('.hero__slide-1:nth-child(2)', { x: slide1Width - 80, opacity: 1, zIndex: -2 }, { zIndex: -2, x: slide1Width, duration: 0.4, opacity: 1 })
				.fromTo('.hero__slide-1:nth-child(3)', { x: slide1Width - 80, zIndex: -3, opacity: 1 }, { zIndex: -3, opacity: 1, x: slide1Width + 80, duration: 0.4 })
				.fromTo('.hero__slide-1:nth-child(4)', { x: slide1Width - 80, zIndex: -4 }, { zIndex: -4, x: slide1Width + 160, duration: 0.4 })
				.fromTo(
					'.hero__slide-1:nth-child(1) .hero__content',
					{
						opacity: 0,
						duration: 0.2,
						ease: 'power2.out',
						// yPercent: -100,
					},
					{
						opacity: 1,
						ease: 'power2.out',
					}
				);

			// Start de pageload animation
			window.addEventListener('load', function () {
				pageloadAnimation.play();
			});

			// ScrollTrigger voor rest van de content
			ScrollTrigger.create({
				trigger: document.body,
				start: 'top 96px',
				endTrigger: '.hero__slides',
				end: 'bottom bottom',
				pin: false,
				toggleActions: 'none none none reverse',
			});
		} else {
			// 	// Code voor mediaquery < 900px
			// // Nieuwe functionaliteit voor <900px schermgrootte

			const pageloadAnimationMobile = gsap.timeline();
			const heroSlideHeight = document.querySelector('.hero__img-container').offsetHeight;

			pageloadAnimationMobile.to('.hero__slide-1:nth-child(1) .hero__content--color', {
				opacity: 1,
				duration: 0.4,
				ease: 'power2.out',
				onComplete: function () {
					gsap.to('.hero__slide-1:nth-child(1) .hero__content--white', {
						opacity: 1,
						y: 0,
						duration: 0.4,
						ease: 'power2.out',
					});
				},
			});

			// Start de pageload animatie direct wanneer de pagina is geladen
			window.addEventListener('load', function () {
				pageloadAnimationMobile.play();
			});

			// ScrollTrigger voor rest van de content
			ScrollTrigger.create({
				trigger: document.body,
				start: 'top top',
				endTrigger: '.hero__slides',
				end: 'bottom bottom',
				pin: false,
				toggleActions: 'none none none reverse',
			});

			//Mobile:
			const tlMobile = gsap.timeline();
			tlMobile
				.to('.hero__slide-1:nth-child(1)', { zIndex: 1, duration: 0 })
				.to('.hero__slide-1:nth-child(1) .hero__content--color', {
					opacity: 1,
					duration: 0.3,
					ease: 'power2.out',
					onComplete: function () {
						gsap.to('.hero__slide-1:nth-child(1) .hero__content--white', {
							opacity: 1,
							y: 0,
							duration: 0.4,
							ease: 'power2.out',
						});
					},
				})
				.from('.hero__slide-1:nth-child(2)', { yPercent: 100, duration: 2, opacity: 1 })
				.to('.hero__slide-1:nth-child(2) .hero__content--color', {
					opacity: 1,
					duration: 0.2,
					ease: 'power2.out',
					scrub: true,
					onComplete: function () {
						gsap.to('.hero__slide-1:nth-child(2) .hero__content--white', {
							opacity: 1,
							y: 0,
							duration: 0.2,
							scrub: true,
							ease: 'power2.out',
						});
					},
				})
				.from('.hero__slide-1:nth-child(3)', { yPercent: 100, duration: 2, opacity: 1 })
				.to('.hero__slide-1:nth-child(3) .hero__content--color', {
					opacity: 1,
					duration: 0.1,
					ease: 'power2.out',
					scrub: true,
					onComplete: function () {
						gsap.to('.hero__slide-1:nth-child(3) .hero__content--white', {
							opacity: 1,
							y: 0,
							duration: 0.1,
							scrub: true,
							ease: 'power2.out',
						});
					},
				})
				.from('.hero__slide-1:nth-child(4)', { yPercent: 100, duration: 2 })
				.to('.hero__slide-1:nth-child(4) .hero__content--color', {
					opacity: 1,
					duration: 0.1,
					ease: 'power2.out',
					scrub: true,
					onComplete: function () {
						gsap.to('.hero__slide-1:nth-child(4) .hero__content--white', {
							opacity: 1,
							y: 0,
							duration: 0.1,
							scrub: true,
							ease: 'power2.out',
						});
					},
				});

			// ScrollTrigger voor dia-animatie
			ScrollTrigger.create({
				animation: tlMobile,
				trigger: '.hero-scroll-mobile',
				start: 'top 96px',
				end: `+=${heroSlideHeight * 5}`,
				scrub: true,
				toggleClass: 'position-mobile',
				pin: true,
				anticipatePin: 1,
			});
		}
	}




// 	addTabNavigationListeners() {
// 		let isShiftPressed = false;

// 		document.addEventListener('keydown', (event) => {
// 			 if (event.key === 'Shift') {
// 				  isShiftPressed = true;
// 			 }
// 		});

// 		document.addEventListener('keyup', (event) => {
// 			 if (event.key === 'Shift') {
// 				  isShiftPressed = false;
// 			 }
// 		});

// 		document.addEventListener('keydown', (event) => {
// 			 if (event.key === 'Tab') {
// 				  // Delay slightly to wait for focus to move to the next slide
// 				  setTimeout(() => {
// 						const focusedSlide = document.activeElement;
// 						if (focusedSlide && focusedSlide.classList.contains('hero__slide-1')) {
// 							 this.focusAnimation(focusedSlide, isShiftPressed);
// 						} else if (isShiftPressed) {
// 							 // If the Shift key is pressed and the focused element is not one of your slides,
// 							 // scroll to the element with id "logo-section"
// 							 const logoSection = document.getElementById('logo-section');
// 							 if (logoSection) {
// 								  logoSection.scrollIntoView({ behavior: 'smooth' });
// 							 }
// 						}
// 				  }, 100);
// 			 }
// 		});
//   }
// 	positionSlides() {
// 		const slides = document.querySelectorAll('.hero__slide-1');
// 		slides.forEach((slide, index) => {
// 			if (index === 0) {
// 				// Hide the first slide from screen readers and make it inaccessible
// 				// slide.setAttribute('aria-hidden', 'true');
// 				slide.removeAttribute('tabindex');
// 			} else {
// 				// The subsequent slides should be focusable with tabindex="0" and visible to screen readers
// 				slide.setAttribute('tabindex', '0');
// 				// slide.setAttribute('aria-hidden', 'false');
// 			}
// 			// The rest of your positioning code remains the same
// 			if (index === 1) {
// 				gsap.set(slide, {
// 					opacity: 1,
// 					zIndex: 1,
// 					scale: 1,
// 					// width: '100%',
// 					transform: 'translateX(0px)',
// 				});
// 			} else {
// 				const xOffset = 80 * index;
// 				gsap.set(slide, {
// 					opacity: 1,
// 					zIndex: 1,
// 					scale: 1,
// 					// width: `calc(100% + ${xOffset}px)`,
// 					// transform: `translateX(${xOffset}px)`,
// 				});
// 			}
// 		});
// 	}

	// addFocusEventListeners() {
	// 	const slides = document.querySelectorAll('.hero__slide-1');
	// 	slides.forEach((slide) => {
	// 		slide.setAttribute('tabindex', '0'); // Ensure slides are focusable
	// 		slide.addEventListener('focus', () => this.focusAnimation(slide), true);
	// 	});
	// }

	// // Modify the focusAnimation method to handle reverse animation
	// focusAnimation(slide, isShiftPressed) {
	// 	const slides = document.querySelectorAll('.hero__slide-1');
	// 	const slideIndex = Array.from(slides).indexOf(slide);

	// 	// Special handling for navigating backwards with Shift + Tab
	// 	if (isShiftPressed) {
	// 		let backwardZIndex;

	// 		// Set the zIndex for the slide when going backwards
	// 		if (slideIndex === -1) {
	// 			backwardZIndex = 1;
	// 		} else {
	// 			backwardZIndex = slideIndex + 1;
	// 		}

	// 		// Apply the animation with adjusted zIndex for backward navigation
	// 		const translateValue = 1089 + 80 * (slideIndex - 1);
	// 		gsap.to(slide, {
	// 			opacity: 1,
	// 			zIndex: backwardZIndex,
	// 			width: '80px',
	// 			boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
	// 			ease: 'power2.out',
	// 			transformOrigin: 'left center',
	// 			transform: `translateX(${translateValue}px)`,
	// 		});

	// 		const content = slide.querySelector('.hero__content');
	// 		const image = slide.querySelector('.hero__img-container');

	// 		// Animate the content and image to fade out when navigating backwards
	// 		gsap.to(content, {
	// 			opacity: 0,
	// 			yPercent: 40,
	// 			ease: 'power2.out',
	// 			duration: 0.3,
	// 		});

	// 		gsap.to(image, {
	// 			opacity: 0,
	// 			x: 80,
	// 			ease: 'power2.out',
	// 			duration: 0.3,
	// 		});

	// 		// Handling the blur event for backward navigation
	// 		slide.addEventListener(
	// 			'blur',
	// 			() => {
	// 				gsap.to(slide, {
	// 					duration: 0.5,
	// 					opacity: 1,
	// 					zIndex: backwardZIndex,
	// 					width: '80px',
	// 					boxShadow: 'none',
	// 					ease: 'power2.out',
	// 					transform: `translateX(${translateValue}px)`,
	// 				});

	// 				// Keep the content and image opacity at 0 when losing focus
	// 				gsap.to(content, { opacity: 0, duration: 0.3 });
	// 				gsap.to(image, { opacity: 0, duration: 0.3 });
	// 			},
	// 			{ once: true }
	// 		);

	// 		return;
	// 	}

	// 	// Forward navigation logic (without Shift key)
	// 	const translateValue = 80 * slideIndex;
	// 	gsap.to(slide, {
	// 		opacity: 1,
	// 		zIndex: 2,
	// 		width: '100%',
	// 		boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
	// 		ease: 'power2.out',
	// 		transformOrigin: 'left center',
	// 		transform: `translateX(${translateValue}px)`,
	// 	});

	// 	// Animation for the content and image of the focused slide
	// 	const content = slide.querySelector('.hero__content');
	// 	const image = slide.querySelector('.hero__img-container');
	// 	gsap.to(content, {
	// 		opacity: 1,
	// 		yPercent: 0,
	// 		ease: 'power2.out',
	// 		duration: 0.3,
	// 	});

	// 	gsap.to(image, {
	// 		opacity: 1,
	// 		x: 0,
	// 		ease: 'power2.out',
	// 		duration: 0.3,
	// 	});

	// 	// Handling the blur event for forward navigation
	// 	slide.addEventListener(
	// 		'blur',
	// 		() => {
	// 			gsap.to(slide, {
	// 				duration: 0.5,
	// 				opacity: 1,
	// 				zIndex: 2,
	// 				width: '100%',
	// 				boxShadow: 'none',
	// 				ease: 'power2.out',
	// 				transform: `translateX(${translateValue}px)`,
	// 			});

	// 			gsap.to(content, {
	// 				opacity: 0,
	// 				yPercent: 40,
	// 				ease: 'power2.out',
	// 				duration: 0.3,
	// 			});

	// 			gsap.to(image, {
	// 				opacity: 0,
	// 				x: 80,
	// 				ease: 'power2.out',
	// 				duration: 0.3,
	// 			});
	// 		},
	// 		{ once: true }
	// 	);
	// }
}
